/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_ccbf33ff',
  item: 'item_ccbf33ff',
};

export = styles;

loadStyles([{"rawString":".root_ccbf33ff{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_ccbf33ff{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */